exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fab-tooltip.tooltip{display:block!important;padding:4px;z-index:10000}.fab-tooltip.tooltip .tooltip-inner{background:#333;color:#fff;border-radius:0;padding:5px 10px 4px}.fab-tooltip.tooltip tooltip-arrow{display:none}.fab-tooltip.tooltip[aria-hidden=true]{visibility:hidden;opacity:0;transition:opacity .15s,visibility .15s}.fab-tooltip.tooltip[aria-hidden=false]{visibility:visible;opacity:1;transition:opacity .15s}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-1073f3cf","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/FAB.vue
// module id = 9
// module chunks = 0